import axiosInstance from './axiosInstance';
import axios from 'axios';

// Fetch users based on userType (old endpoint - kept for backward compatibility)
export const fetchUsers = (userType, limit = 10, offset = 0) => {
    return axiosInstance.post('users', {
        userType,
        limit,
        offset,
    });
};

// Fetch users/organizations with filters, pagination, and export support
export const fetchUsersWithFilters = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add pagination params (only if export is not specified - for export, we want all data)
    if (!params.export) {
        if (params.page) queryParams.append('page', params.page);
        if (params.page_size) queryParams.append('page_size', params.page_size);
    }

    // Add export format if provided (for export)
    if (params.export) queryParams.append('export', params.export);

    // Required parameter
    if (params.user_type) queryParams.append('user_type', params.user_type);

    // Add filter params
    if (params.email) queryParams.append('email', params.email);
    if (params.first_name) queryParams.append('first_name', params.first_name);
    if (params.last_name) queryParams.append('last_name', params.last_name);
    if (params.title) queryParams.append('title', params.title);
    if (params.organization_title) queryParams.append('organization_title', params.organization_title);
    if (params.organization_type) queryParams.append('organization_type', params.organization_type);
    if (params.country) queryParams.append('country', params.country);
    if (params.city) queryParams.append('city', params.city);
    if (params.verified !== undefined && params.verified !== null && params.verified !== '') {
        queryParams.append('verified', params.verified);
    }
    if (params.verified_organization !== undefined && params.verified_organization !== null && params.verified_organization !== '') {
        queryParams.append('verified_organization', params.verified_organization);
    }
    if (params.deleted !== undefined && params.deleted !== null && params.deleted !== '') {
        queryParams.append('deleted', params.deleted);
    }
    if (params.subscribe_status) queryParams.append('subscribe_status', params.subscribe_status);

    // For file downloads (CSV, XLSX), we need to set responseType to 'blob'
    // For JSON export, use default responseType
    // For regular fetch (no export), use default responseType
    const config = params.export && params.export !== 'json'
        ? { responseType: 'blob' }
        : {};

    const response = await axiosInstance.get(`users?${queryParams.toString()}`, config);

    // If export is requested, return the full response (for blob handling)
    // Otherwise, return the data
    return params.export ? response : response.data;
};

// Update user/organization verified status
export const toggleVerifiedStatus = (userId, userType) => {
    return axiosInstance.post('toggle-verified-status', { userType, userId });
};

// Update user/organization deleted status
export const toggleDeletedStatus = (userId, userType) => {
    return axiosInstance.post('toggle-deleted-status', { userType, userId });
};

// fetch opencalls, and toggle visibility status for opencalls (old endpoint - kept for backward compatibility)
export const fetchOpenCalls = (openCallId) => {
    return axiosInstance.get('open-calls');
};

export const togglePinnedOpenCall = (openCallId) => {

    return axiosInstance.post(
        'toggle-pinned-open-call',
        {
            openCallId
        }
    );

};


// fetch open calls with filters, pagination, and export support
export const fetchOpenCallsWithFilters = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add pagination params (only if export is not specified - for export, we want all data)
    if (!params.export) {
        if (params.page) queryParams.append('page', params.page);
        if (params.page_size) queryParams.append('page_size', params.page_size);
    }

    // Add export format if provided (for export)
    // if (params.export) queryParams.append('format', params.export);
    if (params.export) queryParams.append('export', params.export);

    // Add filter params
    if (params.open_call_title) queryParams.append('open_call_title', params.open_call_title);
    if (params.open_call_type) queryParams.append('open_call_type', params.open_call_type);
    if (params.industry_type) queryParams.append('industry_type', params.industry_type);
    if (params.category) queryParams.append('category', params.category);
    if (params.eligibility) queryParams.append('eligibility', params.eligibility);
    if (params.gender) queryParams.append('gender', params.gender);
    if (params.listing_type) queryParams.append('listing_type', params.listing_type);
    if (params.fee_type) queryParams.append('fee_type', params.fee_type);
    if (params.country) queryParams.append('country', params.country);
    if (params.city) queryParams.append('city', params.city);
    if (params.open_call_email) queryParams.append('open_call_email', params.open_call_email);
    if (params.event_date_from) queryParams.append('event_date_from', params.event_date_from);
    if (params.event_date_to) queryParams.append('event_date_to', params.event_date_to);
    if (params.event_deadline_from) queryParams.append('event_deadline_from', params.event_deadline_from);
    if (params.event_deadline_to) queryParams.append('event_deadline_to', params.event_deadline_to);
    if (params.created_at_from) queryParams.append('created_at_from', params.created_at_from);
    if (params.created_at_to) queryParams.append('created_at_to', params.created_at_to);
    if (params.updated_at_from) queryParams.append('updated_at_from', params.updated_at_from);
    if (params.updated_at_to) queryParams.append('updated_at_to', params.updated_at_to);
    if (params.price_min !== undefined && params.price_min !== null && params.price_min !== '') {
        queryParams.append('price_min', params.price_min);
    }
    if (params.price_max !== undefined && params.price_max !== null && params.price_max !== '') {
        queryParams.append('price_max', params.price_max);
    }
    if (params.plan_id !== undefined && params.plan_id !== null && params.plan_id !== '') {
        queryParams.append('plan_id', params.plan_id);
    }
    if (params.visibility !== undefined && params.visibility !== null && params.visibility !== '') {
        queryParams.append('visibility', params.visibility);
    }
    if (params.pinned !== undefined && params.pinned !== null && params.pinned !== '') {
        queryParams.append('pinned', params.pinned);
    }
    if (params.organization_email) queryParams.append('organization_email', params.organization_email);
    if (params.organization_title) queryParams.append('organization_title', params.organization_title);
    if (params.first_name) queryParams.append('first_name', params.first_name);
    if (params.last_name) queryParams.append('last_name', params.last_name);
    if (params.organization_type) queryParams.append('organization_type', params.organization_type);
    if (params.org_country) queryParams.append('org_country', params.org_country);
    if (params.org_city) queryParams.append('org_city', params.org_city);
    if (params.plan_name) queryParams.append('plan_name', params.plan_name);

    // For file downloads (CSV, XLSX), we need to set responseType to 'blob'
    // For JSON export, use default responseType
    // For regular fetch (no export), use default responseType
    const config = params.export && params.export !== 'json'
        ? { responseType: 'blob' }
        : {};

    const response = await axiosInstance.get(`open-calls?${queryParams.toString()}`, config);

    // Return response.data for regular fetch, full response for exports (to access headers)
    return params.export ? response : response.data;
};

// fetch reviews, and toggle visibility status for reviews
export const fetchReviews = (reviewId) => {
    return axiosInstance.post('reviews', { reviewId })
}

// fetch all subscribers
export const fetchSubscribers = () => {
    return axiosInstance.post('subscribers');
};

// fetch all forms submissions, and only contact us form submissions
export const fetchContactFormSubmissions = (contact) => {
    return axiosInstance.post('contact-form-submissions', { contact })
}

// fetch all plans with features
export const fetchPlans = () => {
    return axiosInstance.get('plans');
};

// fetch all coupons with allocated plans
export const fetchCoupons = () => {
    return axiosInstance.get('coupons');
};

export const createCoupon = ({ coupon_code, discount_percent, plan_id }) => {
    return axiosInstance.post('coupons', {
        coupon_code,
        discount_percent,
        plan_id,
    });
};

// fetch all payments (old endpoint - kept for backward compatibility)
export const fetchPayments = () => {
    return axiosInstance.post('payments');
};

// fetch payments with filters, pagination, and export support
export const fetchPaymentsWithFilters = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add pagination params (only if export is not specified - for export, we want all data)
    if (!params.export) {
        if (params.page) queryParams.append('page', params.page);
        if (params.page_size) queryParams.append('page_size', params.page_size);
    }

    // Add export format if provided (for export)
    if (params.export) queryParams.append('export', params.export);

    // Add filter params
    if (params.organization_email) queryParams.append('organization_email', params.organization_email);
    if (params.organization_title) queryParams.append('organization_title', params.organization_title);
    if (params.first_name) queryParams.append('first_name', params.first_name);
    if (params.last_name) queryParams.append('last_name', params.last_name);
    if (params.payment_status) queryParams.append('payment_status', params.payment_status);
    if (params.payment_date_from) queryParams.append('payment_date_from', params.payment_date_from);
    if (params.payment_date_to) queryParams.append('payment_date_to', params.payment_date_to);
    if (params.amount_min !== undefined && params.amount_min !== null && params.amount_min !== '') {
        queryParams.append('amount_min', params.amount_min);
    }
    if (params.amount_max !== undefined && params.amount_max !== null && params.amount_max !== '') {
        queryParams.append('amount_max', params.amount_max);
    }
    if (params.currency) queryParams.append('currency', params.currency);
    if (params.plan_id !== undefined && params.plan_id !== null && params.plan_id !== '') {
        queryParams.append('plan_id', params.plan_id);
    }
    if (params.product) queryParams.append('product', params.product);

    // For file downloads (CSV, XLSX), we need to set responseType to 'blob'
    // For JSON export, use default responseType
    // For regular fetch (no export), use default responseType
    const config = params.export && params.export !== 'json'
        ? { responseType: 'blob' }
        : {};

    const response = await axiosInstance.get(`/payments/export/?${queryParams.toString()}`, config);

    // Return response.data for regular fetch, full response for exports (to access headers)
    return params.export ? response : response.data;
};

// fetch user's purchased plans
export const fetchUsersPlans = () => {
    return axiosInstance.post('users-plans');
};

//fetch all logs
export const fetchLogEntries = () => {
    return axiosInstance.post('log-entries');
};

// fetch all forms submissions, and only contact us form submissions
export const fetchTemplateData = (params) => {
    return axiosInstance.get('get-user-template-data/', { params })
}

// Send Templates Email API
export const sendEmailsAPI = async ({ keys, subject, campaign_name, html_body, batch_count }) => {
    return axiosInstance.post('send-emails', {
        keys,
        subject,
        campaign_name,
        html_body,
        batch_count
    });
};

// Fetch user emails API
export const fetchUserEmailsAPI = async ({ status = null, limit = null, order = 'latest' } = {}) => {
    try {
        const params = new URLSearchParams();
        if (status) params.append('status', status);
        if (limit) params.append('limit', limit);
        if (order) params.append('order', order);

        const response = await axiosInstance.get(`fetch-subscribers?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching subscribers:', error);
        throw error;
    }
};

//schedule an email
export const scheduleEmailAPI = async (emailData) => {
    return axiosInstance.post('schedule-email', emailData);
};

// Fetch Email Campaign Analytics
export const fetchCampaigns = async (params = {}) => {
    const payload = {};

    // Add parameters only if they are provided and non-empty
    if (params.campaign_name) {
        payload.campaign_name = params.campaign_name;
    }

    if (params.date) {
        payload.date = params.date;
    }

    if (params.limit !== undefined) {
        payload.limit = params.limit;
    }

    if (params.offset !== undefined) {
        payload.offset = params.offset;
    }

    // Make the API call
    return axiosInstance.post('campaign-analytics', payload);
};

// Add Artist to Artist Of The Month API
export const addArtistOfMonthAPI = async ({ user_id, month, year }) => {
    return axiosInstance.post('add-artist-of-the-month', {
        user_id,
        month,
        year,
    });
};

// fetch reviews, and toggle visibility status for reviews
export const fetchArtistOfMonthAPI = () => {
    return axiosInstance.get('get-all-artists-of-the-month')
}

// Fetch all artist interviews (old endpoint - kept for backward compatibility)
export const fetchArtistInterviews = () => {
    return axiosInstance.get('artist-interviews');
};

// Fetch artist interviews with filters, pagination, and export support
export const fetchArtistInterviewsWithFilters = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add pagination params (only if export is not specified - for export, we want all data)
    if (!params.export) {
        if (params.page) queryParams.append('page', params.page);
        if (params.page_size) queryParams.append('page_size', params.page_size);
    }

    // Add export format if provided (for export)
    if (params.export) queryParams.append('export', params.export);

    // Add filter params
    if (params.interview_title) queryParams.append('interview_title', params.interview_title);
    if (params.interview_category) queryParams.append('interview_category', params.interview_category);
    if (params.artist_title) queryParams.append('artist_title', params.artist_title);
    if (params.slug) queryParams.append('slug', params.slug);
    if (params.interview_artistic_fields) queryParams.append('interview_artistic_fields', params.interview_artistic_fields);
    if (params.created_at_from) queryParams.append('created_at_from', params.created_at_from);
    if (params.created_at_to) queryParams.append('created_at_to', params.created_at_to);
    if (params.updated_at_from) queryParams.append('updated_at_from', params.updated_at_from);
    if (params.updated_at_to) queryParams.append('updated_at_to', params.updated_at_to);

    // For file downloads (CSV, XLSX), we need to set responseType to 'blob'
    // For JSON export, use default responseType
    // For regular fetch (no export), use default responseType
    const config = params.export && params.export !== 'json'
        ? { responseType: 'blob' }
        : {};

    const response = await axiosInstance.get(`artist-interviews?${queryParams.toString()}`, config);

    // If export is requested, return the full response (for blob handling)
    // Otherwise, return the data
    return params.export ? response : response.data;
};

// Fetch background task logs with filters, pagination, and export support
export const fetchBackgroundTaskLogsWithFilters = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add pagination params (only if format/export is not specified - for export, we want all data)
    const hasExport = params.format || params.export;
    if (!hasExport) {
        if (params.page) queryParams.append('page', params.page);
        if (params.page_size) queryParams.append('page_size', params.page_size);
    }

    // Add export format if provided (for export) - use 'format' to match API endpoint
    if (params.format) queryParams.append('format', params.format);
    if (params.export && !params.format) queryParams.append('format', params.export);

    // Add filter params
    if (params.task_name) queryParams.append('task_name', params.task_name);
    if (params.task_type) queryParams.append('task_type', params.task_type);
    if (params.task_id) queryParams.append('task_id', params.task_id);
    if (params.related_id) queryParams.append('related_id', params.related_id);
    if (params.related_type) queryParams.append('related_type', params.related_type);
    if (params.log_level) queryParams.append('log_level', params.log_level);
    if (params.admin_notification_sent !== undefined && params.admin_notification_sent !== null && params.admin_notification_sent !== '') {
        queryParams.append('admin_notification_sent', params.admin_notification_sent);
    }
    if (params.created_at_from) queryParams.append('created_at_from', params.created_at_from);
    if (params.created_at_to) queryParams.append('created_at_to', params.created_at_to);

    // For file downloads (CSV, XLSX), we need to set responseType to 'blob'
    // For JSON export, use default responseType
    // For regular fetch (no export), use default responseType
    const config = hasExport && hasExport !== 'json'
        ? { responseType: 'blob' }
        : {};

    const response = await axiosInstance.get(`background-task-logs?${queryParams.toString()}`, config);

    // If export is requested, return the full response (for blob handling)
    // Otherwise, return the data
    return hasExport ? response : response.data;
};

// Fetch API logs with filters, pagination, and export support
export const fetchApiLogsWithFilters = async (params = {}) => {
    const queryParams = new URLSearchParams();

    // Add pagination params (only if format/export is not specified - for export, we want all data)
    const hasExport = params.format || params.export;
    if (!hasExport) {
        if (params.page) queryParams.append('page', params.page);
        if (params.page_size) queryParams.append('page_size', params.page_size);
    }

    // Add export format if provided (for export) - use 'format' to match API endpoint
    if (params.format) queryParams.append('format', params.format);
    if (params.export && !params.format) queryParams.append('format', params.export);

    // Add filter params
    if (params.endpoint) queryParams.append('endpoint', params.endpoint);
    if (params.method) queryParams.append('method', params.method);
    if (params.log_level) queryParams.append('log_level', params.log_level);
    if (params.status_code !== undefined && params.status_code !== null && params.status_code !== '') {
        queryParams.append('status_code', params.status_code);
    }
    if (params.error_type) queryParams.append('error_type', params.error_type);
    if (params.user_id !== undefined && params.user_id !== null && params.user_id !== '') {
        queryParams.append('user_id', params.user_id);
    }
    if (params.user_email) queryParams.append('user_email', params.user_email);
    if (params.user_type) queryParams.append('user_type', params.user_type);
    if (params.organization_id !== undefined && params.organization_id !== null && params.organization_id !== '') {
        queryParams.append('organization_id', params.organization_id);
    }
    if (params.view_class) queryParams.append('view_class', params.view_class);
    if (params.view_function) queryParams.append('view_function', params.view_function);
    if (params.created_at_from) queryParams.append('created_at_from', params.created_at_from);
    if (params.created_at_to) queryParams.append('created_at_to', params.created_at_to);

    // For file downloads (CSV, XLSX), we need to set responseType to 'blob'
    // For JSON export, use default responseType
    // For regular fetch (no export), use default responseType
    const config = hasExport && hasExport !== 'json'
        ? { responseType: 'blob' }
        : {};

    const response = await axiosInstance.get(`api-logs?${queryParams.toString()}`, config);

    // If export is requested, return the full response (for blob handling)
    // Otherwise, return the data
    return hasExport ? response : response.data;
};

// Fetch a single artist interview by ID
export const fetchArtistInterviewById = (id) => {
    return axiosInstance.get(`artist-interviews/id=${id}`);
};

// Create or update an artist interview
export const createOrUpdateArtistInterview = (interviewData) => {
    return axiosInstance.post('artist-interviews', interviewData);
};

export const uploadImageAPI = (file) => {
    const formData = new FormData();
    formData.append('files', file);

    return axios.post(`https://dev.opencallforartists.com/users/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Insert subscribers API (Batch Upload)
export const insertSubscribersAPI = async (batch) => {
    try {
        const response = await axiosInstance.post('insert-subscribers', { subscribers: batch });
        return response.data;
    } catch (error) {
        console.error('Error inserting subscribers:', error?.response?.data || error.message);
        throw new Error(error?.response?.data?.message || 'API Error: Failed to insert subscribers');
    }
};

// fetch all coupons with allocated plans
export const fetchInvoices = () => {
    return axiosInstance.get('all-invoices');
};

// scrap data using website url
export const postScraperExtract = (url, pages, campaign_name, category_ids, subcategory_ids) => {
    return axiosInstance.post('start/', { url, pages, campaign_name, category_ids, subcategory_ids });
};

// get progress of the scraping
export const getScraperProgress = (job_id) => {
    return axiosInstance.get(`scraper/progress/${job_id}/`);
};

// API call to trigger sending CSV to admin email
export const sendScraperCSVToEmail = async (type = 'all', website = '', campaign = '') => {
    const response = await axiosInstance.post('scraper/export/', {
        type,
        website,
        campaign,
    });
    return response.data;
};

// get scraping campaign summary data
export const getScraperCampaignSummaries = async () => {
    const response = await axiosInstance.get('scraper/campaign-summary/');
    return response.data;
};


export const previewScraperImport = async (file) => {

    const formData = new FormData();

    formData.append(
        "file",
        file
    );

    const response =
        await axiosInstance.post(
            "scraper/import/preview/",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

    return response.data;
};

export const importScraperFile = async ({
    file,
    campaign_name,
    mappings
}) => {

    const formData = new FormData();

    formData.append(
        "file",
        file
    );

    formData.append(
        "campaign_name",
        campaign_name
    );

    formData.append(
        "mappings",
        JSON.stringify(mappings)
    );

    const response =
        await axiosInstance.post(
            "scraper/import/",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

    return response.data;
};



// Start cold outreach job
export const postStartColdOutreach = async (outreach_email_subject, outreach_email_html, outreach_email_keys, targeted_segment, attachments, category_ids, subcategory_ids) => {
    const response = await axiosInstance.post('/start-cold-outreach/', {
        outreach_email_subject,
        outreach_email_html,
        outreach_email_keys,
        targeted_segment,
        attachments,
        category_ids,
        subcategory_ids
    });
    return response.data;
};

// Track cold outreach job status
export const getColdOutreachStatus = async (job_id) => {
    const response = await axiosInstance.get(`/start-cold-outreach-status/${job_id}/`);
    return response.data;
};


export const previewCleanup = async (info_type, limit) => {
    const response = await axiosInstance.post(
        "scraper/cleanup-preview/",
        {
            info_type,
            limit
        }
    );

    return response.data;
};

export const deleteCleanup = async (info_type, limit) => {
    const response = await axiosInstance.post(
        "scraper/cleanup-delete/",
        {
            info_type,
            limit
        }
    );

    return response.data;
};

export const getScraperCategories = async () => {
    const response =
        await axiosInstance.get(
            "scraper/categories"
        );

    return response.data;
};

export const createScraperCategory = async (
    name
) => {

    const response =
        await axiosInstance.post(
            "scraper/categories",
            { name }
        );

    return response.data;
};

export const updateScraperCategory =
    async (
        id,
        name
    ) => {

        const response =
            await axiosInstance.put(
                "scraper/categories",
                {
                    id,
                    name
                }
            );

        return response.data;
    };

export const deleteScraperCategory =
    async (
        id
    ) => {

        const response =
            await axiosInstance.delete(
                "scraper/categories",
                {
                    data: { id }
                }
            );

        return response.data;
    };


export const getScraperSubcategories = async () => {
    const response =
        await axiosInstance.get(
            "scraper/subcategories"
        );

    return response.data;
};

export const createScraperSubcategory =
    async (
        category_id,
        name
    ) => {

        const response =
            await axiosInstance.post(
                "scraper/subcategories",
                {
                    category_id,
                    name
                }
            );

        return response.data;
    };


export const updateScraperSubcategory =
    async (
        id,
        category_id,
        name
    ) => {

        const response =
            await axiosInstance.put(
                "scraper/subcategories",
                {
                    id,
                    category_id,
                    name
                }
            );

        return response.data;
    };

export const deleteScraperSubcategory =
    async (
        id
    ) => {

        const response =
            await axiosInstance.delete(
                "scraper/subcategories",
                {
                    data: { id }
                }
            );

        return response.data;
    };

export const getScraperCampaigns = async () => {
    const response =
        await axiosInstance.get(
            "scraper/campaigns"
        );

    return response.data;
};

export const updateCampaignCategories =
    async (payload) => {

        const response =
            await axiosInstance.post(
                "scraper/campaigns",
                payload
            );

        return response.data;
    };


export const getCampaignPreview =
    async (campaignName) => {

        const response =
            await axiosInstance.get(
                "scraper/campaign-preview/",
                {
                    params: {
                        campaign_name: campaignName
                    }
                }
            );

        return response.data;
    };

// ===============================================
// Analytics Dashboard
// ===============================================
export const fetchAnalyticsDashboard = async () => {
    const response = await axiosInstance.get(
        "analytics/dashboard"
    );
    return response.data;
};

export const exportAnalyticsDashboard = async (format) => {
    return await axiosInstance.get(
        "analytics/dashboard/export",
        {
            params: {
                export: format,
            },
            responseType: format === "json" ? "json" : "blob",
        }
    );
};

export const fetchMarketingAnalytics = async (filters = {}) => {
    const response = await axiosInstance.get(
        "analytics/marketing",
        {
            params: filters,
        }
    );
    return response.data;
};

export const searchMarketingVisitor = async (search) => {
    const response = await axiosInstance.get(
        "analytics/marketing/search",
        {
            params: { search },
        }
    );
    return response.data;
};

export const fetchMarketingFunnel = async (filters = {}) => {
    const response = await axiosInstance.get(
        "analytics/marketing/funnel",
        {
            params: filters,
        }
    );
    return response.data;
};

// ===============================================
// Analytics User Journey
// ===============================================
export const fetchUserJourney = async (params = {}) => {
    const response = await axiosInstance.get(
        "analytics/user-journeys",
        { params, }
    );
    return response.data;
};

export const fetchUserJourneyDetail = async (visitorId) => {
    const response = await axiosInstance.get(
        `analytics/user-journeys/${visitorId}`
    );
    return response.data;
};

export const exportUserJourney = async (params = {}) => {

    const config = params.export !== "json" ? { responseType: "blob" } : {};
    const response = await axiosInstance.get(
        "analytics/user-journeys/export",
        {
            params,
            ...config,
        }
    );
    return response;
};

// ===============================================
// Analytics Filter Options
// ===============================================
export const fetchJourneyFilterOptions = async () => {
    const response = await axiosInstance.get(
        "analytics/journey/filter-options/"
    );
    return response.data;
};

// ===============================================
// Analytics Audience
// ===============================================
export const fetchAnalyticsAudience = async (filters = {}) => {
    const response = await axiosInstance.get(
        "analytics/audience",
        {
            params: filters,
        }
    );
    return response.data;
};

// =========================================
// Cold Outreach Analytics
// =========================================
export const getColdOutreachDashboard = async () => {
    const response = await axiosInstance.get(
        "cold-outreach-dashboard/"
    );

    return response.data;
};

export const getColdOutreachHistory = async (
    page = 1,
    page_size = 10
) => {

    const response = await axiosInstance.get(
        `cold-outreach-history/?page=${page}&page_size=${page_size}`
    );

    return response.data;
};